module.exports = {
  ANFRAGE: { api: 'ANFRAGE', human: 'Anfrage' },
  ANGEBOT: { api: 'ANGEBOT', human: 'Angebot' },
  INFO: { api: 'INFO', human: 'Info' },
  EIGEN: { api: 'EIGEN', human: 'Eigen' },
  RUHEND: { api: 'RUHEND', human: 'ruhend' },
  STORNO: { api: 'STORNO', human: 'storniert' }
}
